import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Grid } from '@material-ui/core'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications'
import NaturePeopleIcon from '@material-ui/icons/NaturePeople'
import { withFirebase } from '../Firebase'
import Projects from '../Projects'

class Intro extends React.Component {

    componentWillMount() {
        window.scrollTo(0, 0)
    }

    render() {

        const handleBannerClick = () => {
            this.props.firebase.getDoc('buttons', 'introBanner', doc => {
                this.props.firebase.setDoc('buttons', 'introBanner', { clicks: doc.clicks + 1 })
            })
        }

        const bannerHeader = (
            <Grid container spacing={16} justify='center' alignItems='center' style={{ minHeight: '400px', backgroundImage: 'url("https://i.imgur.com/W2IBMsB.jpg")', backgroundSize: 'cover', }}>
                <Grid item xs={12} md={5} container spacing={16} direction='column' justify='center' alignItems='center'>
                    <Grid item>
                        <span style={{ fontSize: '2.5em', color: 'lightblue', textShadow: '-1px 0 blue, 0 1px blue, 1px 0 blue, 0 -1px blue' }}>fractal_strategies</span>
                    </Grid>
                    <Grid item>
                        <span style={{ fontSize: '1.5em', color: 'white' }}>apps and robots to automate work</span>
                    </Grid>
                    <Grid item>
                        &nbsp;
                    </Grid>
                    <Grid item>
                        <Button variant='contained' color='primary' component={Link} to='/pricing' onClick={handleBannerClick}>
                            get started
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5}>
                    <iframe width={window.innerWidth < 400 ? '280px' : '420px'} height='315px' title='mandelbrot zoom' src='https://www.youtube.com/embed/pCpLWbHVNhk\?autoplay=0'></iframe>
                </Grid>
            </Grid>
        )

        const bannerIcons = (
            <Grid container style={{
                minHeight: '250px',
                backgroundColor: 'rgb(190, 230, 255)',
                padding: '20px'
            }}>
                <Grid item sm={4} xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 30px' }}>
                    <AccountBoxIcon style={{ fontSize: 50 }} />
                    <h3>User Experience Focused</h3>
                    <p>Using Material UI, FlexBox and FireBase, we create frameworks that incorporate Components and Animations that provide more feedback to Users.</p>
                </Grid>
                <Grid item sm={4} xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 30px' }}>
                    <SettingsApplicationsIcon style={{ fontSize: 50 }} />
                    <h3>Automated Data Flows</h3>
                    <p>Data delivered. Choose your source. We build scheduled data pipelines for collection, transformation and storage.</p>
                </Grid>
                <Grid item sm={4} xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 30px' }}>
                    <NaturePeopleIcon style={{ fontSize: 50 }} />
                    <h3>Easy to work with</h3>
                    <p>Your project starts with you. We will meet you where you are technically, and build from there. We are always open to questions and feedback.</p>
                </Grid>
            </Grid>
        )

        const bannerAloe = (
            <div ref='bannerAloe' style={{
                height: '400px',
                backgroundImage: 'url("https://i.imgur.com/GOk0RhF.jpg")',
                backgroundSize: 'cover',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '2em',
                color: 'rgb(190, 255, 230)',
                textShadow: '-1px 0 green, 0 1px green, 1px 0 green, 0 -1px green'
            }}>
                <span>modern, responsive <b>frontends</b></span>
                <span>supported by</span>
                <span>automated, scalable <b>backends</b></span>
            </div>
        )

        const contactUs = (
            <div style={{
                height: '400px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0 15%',
                fontSize: '1.2em',
            }}>
                <h3>contact us</h3>
                <span>How do you eat an elephant? One bite at a time.</span>
                <br />
                <span>Each goal is unique. Each project requires planning. Each step demands attention.</span>
                <br />
                <span>Let us know about your data needs.</span>
            </div>
        )

        const bannerToday = (
            <div style={{
                height: '400px',
                backgroundImage: 'url("https://i.imgur.com/0cD7Qtk.png")',
                backgroundSize: 'cover',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '1.5em',
                color: 'rgb(255, 255, 230)',
                textShadow: '-1px 0 lightorange, 0 1px lightorange, 1px 0 lightorange, 0 -1px lightorange'
            }}>
                <span>today is a good day</span>
                <br />
                <span>let's get started</span>
            </div>
        )

        const bannerAbout = (
            <Grid container spacing={24} direction='column' alignItems='center' style={{
                minheight: '400px',
                textAlign: 'left',
                fontSize: '1.1em',
                paddingBottom: '20px',
            }}>
                <Grid item container spacing={40} justify='center'>
                    <Grid item md={6} xs={10}>
                        <h3>about us</h3>
                        <span>We are a team of designers and engineers building creative software solutions. Every step in the right direction counts. Grown out of Chicago and based in the cloud, Fractal Strategies combines modern open-source tools with a creative sense of purpose to make apps.</span>
                        <br /><br />
                        <span>Have an app idea? Ask us how to get it off the ground!</span>
                        <br /><br />
                        <Button variant='contained' color='primary' component={Link} to='/contactus'>
                            contact us
                        </Button>
                    </Grid>
                    <Grid item md={2} xs={10}>
                        <h3>clients</h3>
                        <span>CartaTrails</span><br />
                        <span>Alpha Quality Inc</span><br />
                        <span>The Arastu Family</span><br />
                        <span>Dr. Richard P. Feynman</span><br />
                        <span>John Crane</span><br />
                        <span>Ryhana's Cuisine</span><br />
                        <span>Fractal Strategies Inc</span><br />
                    </Grid>
                    <Grid item md={2} xs={10}>
                        <h3>products</h3>
                        <span>Websites</span><br />
                        <span>Web Apps</span><br />
                        <span>Domain Registration</span><br />
                        <span>Email Automation</span><br />
                        <span>Database Administration</span><br />
                        <span>User Authentication</span><br />
                        <span>Web Scraping</span><br />
                        <span>Visualizations</span><br />
                        <span>ETL / ELT</span><br />
                        <span>BI / ML / DL</span><br />
                    </Grid>
                </Grid>
            </Grid>
        )

        return (
            <div>
                {bannerHeader}
                {bannerIcons}
                {bannerAloe}
                <Projects />
                {contactUs}
                {bannerToday}
                {bannerAbout}
            </div>
        )

    }

}

export default withFirebase(Intro)
